<template>
  <div>
    <v-list>
      <v-list-item :ripple="false" v-if="!nonDesktopMode" class="sport-is-selected-desktop">
        <v-list-item-avatar size="24">
          <!--          <v-img :src="BackIcon400" id="back-to-sports" @click="unSelectSport"></v-img>-->
          <v-icon
            id="back-to-sports" @click="unSelectSport"
          >
            krypt-arrow-left
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-title v-if="sportData" @click="setSelectedSport(sportData)">
          {{$t(`sports.${sportData.sportIdentifier}`)}}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <div v-bind:class="{'sidebar-scrollbar':!nonDesktopMode}">
      <v-list>
        <v-list-group :ripple="false" value="true" class="sidebar-section-header"
                      v-show="topTournaments.length >0" append-icon="krypt-arrow-down"
                      :eager="true">
          <template v-slot:activator class="">

            <v-list-item-content>
              <v-list-item-title class="sidebar-root-header">{{ $t('sidebar.topCompetitions') }}
              </v-list-item-title>
            </v-list-item-content>

          </template>
          <v-divider></v-divider>


          <template
            v-for="(tournament,index) in topTournaments"

          >
            <v-list-item
              :key="tournament.id"
              :ripple="false"
              class="top-categories-item"
              v-bind:class="(tournament.id === selectedCompetition.id || tournament.id === mobileDialogPayloads.tournament.id) ? 'item-is-selected' : ''"
              @click="selectTournament(tournament)"

            >

              <v-list-item-content>
                <v-list-item-title>{{tournament.name}}&nbsp; <small style="font-size:12px;">({{tournament.category}})</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive > 0"
              >
                <v-list-item-action-text
                  v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive"></v-list-item-action-text>
              </v-list-item-action>
              <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped > 0">
                <v-list-item-action-text
                  v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped"></v-list-item-action-text>
              </v-list-item-action>
              <v-list-item-action :class="'total-indication'" v-if="tournament.liveNow > 0">
                <v-list-item-action-text v-text="tournament.liveNow"></v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>


            <v-divider v-if="index+1!= topTournaments.length"></v-divider>
          </template>

        </v-list-group>
      </v-list>
      <!-- <v-divider></v-divider> -->
      <v-list>
        <v-list-group value="true"
                      class="sidebar-section-header"
                      append-icon="krypt-arrow-down"
                      :eager="true"

                      :ripple="false">
          <template v-slot:activator
          >

            <v-list-item-content v-if="showAllCategoriesFlag || topCategories.length === 0">
              <v-list-item-title class="sidebar-root-header">{{ $t('sidebar.allCategories') }}
              </v-list-item-title>

            </v-list-item-content>
            <v-list-item-content v-if="!showAllCategoriesFlag && topCategories.length > 0">
              <v-list-item-title class="sidebar-root-header">{{ $t('sidebar.topCategories') }}
              </v-list-item-title>

            </v-list-item-content>
          </template>
          <v-divider></v-divider>
          <template v-for="(categoryObject,categoryKey ) in topCategories"
                    v-if="!showAllCategoriesFlag && topCategories.length > 0">
            <v-list>
              <v-list-group
                :ripple="false"
                :key="categoryObject.id"
                class="category-group"
                append-icon="krypt-arrow-down"
                :eager="true"
                :value="expandedCategory === categoryObject.id"
                @click="selectCategory($event,categoryObject)"
              >
                <template v-slot:activator>
                  <v-list-item-content
                    v-bind:class="(selectedCategory.id === categoryObject.id || categoryObject.id == mobileDialogPayloads.category.id ) ? 'item-is-selected' : ''">
                    <v-list-item-title v-text="categoryObject.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[categoryObject.sportId] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsActive > 0"
                  >
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[categoryObject.sportId] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsStopped > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication float-right category-total'"
                                      v-if="categoryObject.liveNow > 0">
                    <v-list-item-action-text
                      v-text="categoryObject.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </template>

                <v-list-item
                  v-if="!nonDesktopMode"
                  v-for="tournament in tournamentsGroupedByCategory[categoryObject.id]"
                  :key="tournament.id"
                  class="categories-sub-list-item"
                  v-bind:class="(tournament.id === selectedCompetition.id) ? 'item-is-selected' : ''"
                  :ripple="false"
                  :selectable="true"
                  @click="selectTournament(tournament)"
                >
                  <v-list-item-content>

                    <v-list-item-title v-text="tournament.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication'" v-if="tournament.liveNow > 0">
                    <v-list-item-action-text v-text="tournament.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </v-list-item>
                <v-list-item
                  v-if="nonDesktopMode"
                  v-for="tournament in mobileDialogPayloadsGroupedByCategory[categoryObject.id]"
                  :key="tournament.id"
                  class="categories-sub-list-item"
                  v-bind:class="(tournament.id === mobileDialogPayloads.tournament.id) ? 'item-is-selected' : ''"

                  :ripple="false"
                  @click="selectTournament(tournament)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="tournament.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication'" v-if="tournament.liveNow>0">
                    <v-list-item-action-text v-text="tournament.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </v-list-item>
              </v-list-group>

            </v-list>
            <v-divider></v-divider>

          </template>
          <template v-for="(categoryObject,categoryKey ) in allCategories"
                    v-if="showAllCategoriesFlag || topCategories.length === 0">
            <v-list>

              <v-list-group
                :value="expandedCategory === categoryObject.id"
                :ripple="false"
                :key="categoryObject.id"
                append-icon="krypt-arrow-down"
                :eager="true"

                class="category-group"
                @click="selectCategory($event,categoryObject)"
              >
                <template v-slot:activator>
                  <v-list-item-content
                    v-bind:class="(selectedCategory.id === categoryObject.id || categoryObject.id == mobileDialogPayloads.category.id ) ? 'item-is-selected' : ''">
                    <v-list-item-title v-text="categoryObject.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[categoryObject.sportId] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsActive > 0"
                  >
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[categoryObject.sportId] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id] &&
              botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsStopped > 0">
                    <v-list-item-action-text
                      v-text="botMarketMakingTree[categoryObject.sportId].supportedCategoriesMap[categoryObject.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication float-right category-total'"
                                      v-if="categoryObject.liveNow > 0">
                    <v-list-item-action-text
                      v-text="categoryObject.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </template>

                <v-list-item
                  v-if="!nonDesktopMode"
                  v-for="tournament in tournamentsGroupedByCategory[categoryObject.id]"
                  :key="tournament.id"
                  class="categories-sub-list-item"
                  v-bind:class="(tournament.id === selectedCompetition.id) ? 'item-is-selected' : ''"
                  :ripple="false"
                  :selectable="true"
                  @click="selectTournament(tournament)"
                >
                  <v-list-item-content>

                    <v-list-item-title v-text="tournament.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive > 0">
                    <v-list-item-action-text v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped > 0">
                    <v-list-item-action-text v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication'" v-if="tournament.liveNow > 0">
                    <v-list-item-action-text v-text="tournament.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </v-list-item>
                <v-list-item
                  v-if="nonDesktopMode"
                  v-for="tournament in mobileDialogPayloadsGroupedByCategory[categoryObject.id]"
                  :key="tournament.id"
                  class="categories-sub-list-item"
                  v-bind:class="(tournament.id === mobileDialogPayloads.tournament.id) ? 'item-is-selected' : ''"

                  :ripple="false"
                  @click="selectTournament(tournament)"
                >
                  <v-list-item-content>

                    <v-list-item-title v-text="tournament.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action :class="'bot-active-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive > 0">
                    <v-list-item-action-text v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsActive"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'bot-inactive-indication'" v-if="
              botMarketMakingTree[tournament.sportId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id] &&
              botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped > 0">
                    <v-list-item-action-text v-text="botMarketMakingTree[tournament.sportId].supportedCategoriesMap[tournament.categoryId].supportedTournamentsMap[tournament.id].botsStopped"></v-list-item-action-text>
                  </v-list-item-action>
                  <v-list-item-action :class="'total-indication'" v-if="tournament.liveNow > 0">
                    <v-list-item-action-text v-text="tournament.liveNow"></v-list-item-action-text>
                  </v-list-item-action>

                </v-list-item>
              </v-list-group>

            </v-list>
            <v-divider></v-divider>

          </template>
          <v-list-item class="all-categories-list-item" :ripple="false"
                       v-if="!showAllCategoriesFlag && topCategories.length > 0">
            <v-btn text class="float-right all-categories-button" :ripple="false"
                   min-width="calc(100% - 8px)"
                   @click="showAllCategories"
            >
              <v-icon
                size="24"
                class="all-categories-button-icon"
              >
                krypt-more-horizontal
              </v-icon>
              <span class="all-categories-button-text">{{ $t('sidebar.allCategories')  | removeDiacriticsFromUppercase}}</span>
            </v-btn>

          </v-list-item>
          <v-list-item class="all-categories-list-item" :ripple="false"
                       v-if="showAllCategoriesFlag && topCategories.length > 0">
            <v-btn text class="float-right all-categories-button" :ripple="false"
                   min-width="calc(100% - 8px)"
                   @click="hideAllCategories"
            >
              <v-icon
                size="24"
                class="all-categories-button-icon"
              >
                krypt-more-horizontal
              </v-icon>
              <span class="all-categories-button-text">{{ $t('sidebar.topCategories')  | removeDiacriticsFromUppercase}}</span>
            </v-btn>
          </v-list-item>
          <v-divider v-if="topCategories.length > 0"></v-divider>

        </v-list-group>
        <!--      <v-footer v-if="hasNonPromotedCategories && !nonDesktopMode"-->
        <!--                class="font-weight-medium text-right float-right all-categories-button" min-width="100%" style="padding-right: 0px"-->
        <!--      >-->
        <!--        <v-btn text class="float-right all-categories-button" :ripple="false"  min-width="100%"><v-icon>mdi-dots-horizontal</v-icon>{{ $t('sidebar.allCategories')}}</v-btn>-->

        <!--      </v-footer>-->
      </v-list>
    </div>
  </div>

</template>

<script>
import BackIcon from '../assets/utility/Arrow Left.svg';
import BackIcon400 from '../assets/utility/Arrow_Left_400.svg';
import MoreIcon from '../assets/utility/More (Horizontal).svg';
import CheckboxUnselected from '../assets/utility/Check Box Unselected.jpg';

export default {
  name: 'CompetitionsList',
  methods: {
    showAllCategories: function () {
      this.showAllCategoriesFlag = true;
    },
    hideAllCategories: function () {
      this.showAllCategoriesFlag = false;
    },
    resetFiltersOfSport: function () {
      this.$store.dispatch('resetAllFiltersForSportAndEvent');
    },
    clickedEntireCategory: function (event, category) {
      event.stopPropagation();
      console.log(category);
    },
    unSelectSport: function () {
      this.$store.commit('setSelectedEvent', 'none');
      this.$store.dispatch('selectSportAndResetEvent', 'none');
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    setSelectedSport: function (sport) {
      this.$store.dispatch('selectSportAndResetEvent', sport);
      this.$store.commit('setSelectedCategory', 'none');
      this.$store.commit('setSelectedTournament', 'none');
      this.$store.commit('setSelectedEvent', 'none');

      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    selectTournament: function (tournament) {
      if (this.nonDesktopMode) {
        this.$store.commit('setSelectedTournamentMobile', tournament);
      } else {
        this.$store.commit('setSelectedEvent', 'none');
        this.$store.commit('setSelectedTournament', tournament
        );
      }
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    selectCategory: function (event, category) {
      event.preventDefault();

      if (this.nonDesktopMode) {
        this.$store.commit('setSelectedCategoryMobile', category);
      } else {
        this.$store.commit('setSelectedEvent', 'none');
        this.$store.commit('setSelectedCategory', category
        );
      }
      this.showCategory(category.id);
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    showCategory: function (categoryId) {
      if (this.expandedCategory != categoryId) {
        this.expandedCategory = categoryId;
      } else {
        // this.expandedCategory = 'none'
      }
    }

  },
  watch: {},
  data: function () {
    return {
      expandedCategory: 'none',
      showAllCategoriesFlag: false,
      CheckboxUnselected: CheckboxUnselected,
      BackIcon: BackIcon,
      MoreIcon: MoreIcon,
      BackIcon400: BackIcon400,
    };
  },
  computed: {
    botMarketMakingTree: function () {
      return this.$store.state.trader.bettingBot.supportedSportsMap;
    },

    mobileDialogPayloads: function () {
      return this.$store.state.navigations.mobileDialogPayloads;
    },
    mobileDialogPayloadsGroupedByCategory: function () {
      let groupedTournaments = {};
      this.sportData.categories.forEach((category) => {
        groupedTournaments[category.id] = [];
      });
      this.sportData.tournaments.forEach((tournament) => {
          groupedTournaments[tournament.categoryId].push(tournament);
        }
      );
      return groupedTournaments;
    },
    nonDesktopMode: function () {
      return (this.$store.state.deviceMode !== 'desktop');
    },
    selectedSport: function () {
      return this.$store.state.navigations.selectedSport;
    },
    selectedCategory: function () {
      return this.$store.state.navigations.selectedCategory;
    },
    selectedCompetition: function () {
      return this.$store.state.navigations.selectedTournament;
    },
    sportData: function () {
      let reactiveSportData;
      let selectedSportId = this.$store.state.navigations.selectedSportData.id;
      reactiveSportData = this.$store.state.navigations.sports.find((sport) => {
        return sport.id === selectedSportId;
      });
      return reactiveSportData;
    },
    topTournaments: function () {
      return (this.sportData ? this.sportData.tournaments.filter((tournament) => {
        return tournament.promoted === true;
      }) : []);

    },
    topCategories: function () {
      return (this.sportData ? this.sportData.categories.filter((tournament) => {
        return tournament.promoted === true;
      }) : []);

    },
    allCategories: function () {
      return (this.sportData ? this.sportData.categories.slice().sort((a, b) => a.name.localeCompare(b.name)) : []);

    },
    hasNonPromotedCategories: function () {
      return this.topCategories.length !== this.$store.state.navigations.selectedSportTopCategories.length;
    },
    tournamentsGroupedByCategory: function () {
      let groupedTournaments = {};
      this.sportData.categories.forEach((category) => {
        groupedTournaments[category.id] = [];
      });
      this.sportData.tournaments.forEach((tournament) => {
          groupedTournaments[tournament.categoryId].push(tournament);
        }
      );
      return groupedTournaments;

    },
  }
};
</script>

<style scoped>

  .v-list-item__action.bot-active-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: white !important;
    min-width: 20px;
    background: var(--primary);
    border-radius: 16px;
  }

  .v-list-item__action.bot-active-indication > .v-list-item__action-text {
    display: flex;
    color: white !important;
  }

  .v-list-item__action.bot-inactive-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: white !important;
    min-width: 20px;
    background: var(--cyborg);
    border-radius: 16px;
  }

  .v-list-item__action.bot-inactive-indication > .v-list-item__action-text {
    color: white !important;
  }
  >>> .v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
    transform: rotate(-180deg) !important;
  }

  >>> .v-icon.v-icon {
    transform: rotate(0deg);
  }

  >>> .krypt-arrow-down {
    color: #0C1016 !important;
  }

  .theme--light.v-btn:hover::before,
  .theme--light.v-btn:focus::before {
    opacity: 0
  }

  .sport-is-selected-desktop {
    color: #0C1016;
    font-weight: bold;
    font-size: 14px;
    background-color: #FAFAFA; /* 100 */
  }

  .sport-is-selected-desktop.v-list-item {
    cursor: default;
  }

  .sport-is-selected-desktop .v-list-item__title {
    margin-top: 4px;
    margin-bottom: 4px;
    margin-left: 0px;
  }

  .v-list {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .v-sheet.v-list {
    padding: 0
  }

  .v-application--is-ltr .v-list-item__avatar:first-child {
    margin-bottom: 8px;
    margin-top: 8px;
    margin-right: 8px;
  }

  .v-application--is-ltr .sport-is-selected-desktop .v-list-item__avatar:first-child {
    margin-right: 16px;
  }

  .v-divider {
    border-width: 1px 1px 0px;
  }

  .theme--light.v-navigation-drawer .v-divider {
    border-color: #F4F5F7;

  }

  .v-list-item__action.total-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    margin-top: 0px;
    margin-bottom: 0px;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: #5c5f61 !important;
    /* 200 */
    min-width: 20px;
    background: #F4F5F7;
    border-radius: 16px;
  }

  .v-list-item__action-text {
    position: static;
    left: 22.73%;
    right: 22.73%;
    top: 11.11%;
    bottom: 11.11%;

    /* 9 XXS / Bold */

    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;

    /* 600 */

    color: #5C5F61;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    align-self: center;
    margin: 0px 0px;
  }

  .v-list-item {
    padding-left: 8px !important;
    margin-left: 0px;
    padding-right: 16px;
    min-height: 0px;
  }

  >>> .category-group > .v-list-group__header.v-list-item {
    min-height: 0px;
    padding-left: 8px;
  }

  >>> .categories-sub-list-item.v-list-item {
    padding-left: 16px !important;
  }

  >>> .category-group > .v-list-group__items > .categories-sub-list-item.v-list-item .v-list-item__title {
    font-size: 12px;
    line-height: 16px;
  }

  .v-list-item__title {
    font-size: 0.875rem;
  }

  #back-to-sports, .v-list-item {
    cursor: pointer;
  }

  #back-to-sports {
    color: #A0A3A5;
  }

  #back-to-sports:hover {
    color: #5c5f61;
  }

  #back-to-sports.theme--light.v-icon:focus::after {
    opacity: 0;
  }

  >>> .sidebar-section-header > .v-list-group__header {
    color: #1976d2;
    /*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);*/
    background: #FAFAFA;
    min-height: 0px; /* to cancel min-height 48px */
  }

  >>> .v-list-group__header.v-list-item.v-list-item--link.theme--light:before {
    color: #1976d2;
    /*box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);*/
    background: #FAFAFA;
  }

  >>> .sidebar-section-header > .v-list-group__header.v-list-item.v-list-item--link.theme--light {
    padding-left: 8px;
  }

  .categories-sub-list-item {
    padding-left: 20px;
  }

  .top-categories-item {
    padding-left: 20px;

  }

  /* not needed - paddings applied at item level
  >>>.v-list-group__header.v-list-item.v-list-item--link.theme--light,.category-group{
    padding-left: 10px;
  } */
  /* not needed - paddings applied at the item level
  >>>.v-list-group__items{
    padding-left: 10px;
  } */
  >>> .v-input--selection-controls__input > .v-icon {
    /* 100 */

    /*background: #979797;*/
    /* 300 */

    /*border: 1px solid #E4E4E4;*/
    /*color: #E4E4E4;*/
    color: inherit;
    box-sizing: border-box;
    border-radius: 1px;
  }

  >>> .v-input--selection-controls__input:hover {
    /* 100 */

    /*background: #979797;*/
    /* 300 */

    /*border: 1px solid #E4E4E4;*/
    color: #A0A3A5 !important;
    box-sizing: border-box;
    border-radius: 2px;
  }

  >>> .v-input--selection-controls__input {
    color: #E4E4E4;

  }

  .sidebar-root-header {
    font-style: normal;
    color: #17A3F2 !important;
    font-weight: bold;
    line-height: 16px !important;
    font-size: 12px !important;
  }

  .more-icon {
    /*color: #727779!important;*/

    /*opacity: 0.6;*/
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 2px;
  }

  >>> .all-categories-button {
    /* background: #FFFFFF!important; changed to transparent to let the highlight work correctly */
    background: none !important;
    /*min-width: calc(100% - 8px) !important;*/
    color: #a0a3a5 !important;
    font-weight: bold;
    font-size: 10px !important;
    line-height: 14px;
    padding-left: 0px !important;
    padding-right: 0px !important;
    /* margin-left:8px; although required for true centring, it's removed because it visually looks better */
    height: auto !important;
    text-indent: 0;
  }

  >>> .all-categories-button:hover {
    color: #727779 !important;
  }

  /* removed because it breaks the whole flex setup for no reason
    .category-total{
      right: 45px;
      top: 4px!important;
      position: absolute;
    } */
  >>> .v-icon.notranslate.mdi.mdi-checkbox-marked {
    color: #1976d2;
  }

  .v-application--is-ltr .v-list-item__action:first-child {
    margin-right: 8px;
  }

  >>> .v-list-item__icon.v-list-group__header__append-icon {
    margin-left: 8px !important;
    margin-top: 4px !important;
    margin-bottom: 4px !important;
    min-width: 0px !important;
    width: 20px !important;
    height: 20px !important;
  }

  >>> .v-list-item__icon.v-list-group__header__append-icon .v-icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-is-selected {
    font-weight: 700 !important;
    color: #0C1016 !important;
  }

  >>> .v-list-group--active > .v-list-group__header .v-list-item, .v-list-group--active > .v-list-group__header .v-list-item__content, .v-list-group--active .item-is-selected > .v-list-group__header .v-list-group__header__prepend-icon .v-icon {
    color: #0C1016;

  }

  .sidebar-section-header .v-list-group__items .v-list-item__content,
  .sidebar-section-header .category-group .v-list-group__header .v-list-item__content {
    padding: 0px;
    margin-top: 8px;
    margin-bottom: 8px;
    margin-left: 8px;
  }

  .sidebar-section-header .v-list-group__header .v-list-item__content {
    padding: 0px;
    margin-top: 4px;
    margin-bottom: 4px;
    margin-left: 8px;
  }

  /* disable default highlight */
  .theme--light.v-list-item:hover::before,
  .theme--light.v-list-item:focus::before {
    opacity: 0;
  }

  /* implement highlight 100 */

  >>> .v-list-item:hover {
    background-color: #fafafa !important;
  }

  @media screen and (max-width: 1279px) {
    >>> .v-list-item:hover {
      background-color: white !important;
    }

    >>> .sidebar-section-header > .v-list-group__header:hover {
      background: #FAFAFA !important;
    }
  }

  >>> .v-list-item.all-categories-list-item:hover {
    background-color: white !important;
  }

  /* margin moved to new span of the text
  >>>.all-categories-button .v-btn__content{
    margin-top:8px;
    margin-bottom:8px;
  } */
  .all-categories-button-text {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .all-categories-button-icon {
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 2px;
  }

  .sidebar-scrollbar {
    overflow: hidden;
    height: calc(100vh - 40px);
    scrollbar-width: thin;
    overscroll-behavior: contain;
  }

  .sidebar-scrollbar > div,
  .sidebar-scrollbar > hr {
    width: 256px;
  }

  .sidebar-scrollbar:hover {
    overflow-y: auto;
  }

  .sidebar-scrollbar::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
  }

  .sidebar-scrollbar::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }

  .sidebar-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
  }

  >>> .sport-is-selected-desktop > .v-list-item__title {
    cursor: pointer;
  }

</style>
